import L from 'leaflet';

const iconPerson = new L.Icon({
    iconUrl: '/assets/images/robot-icon (1).svg',
    iconRetinaUrl:'/assets/images/robot-icon (1).svg',
    iconAnchor: null,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(60, 75),
});

export { iconPerson };